import styled, { keyframes } from "styled-components"

import { MEDIA_QUERIES } from "@constants"

const ModalAnimationInKeyframes = keyframes`
  0% {
    opacity: 0;
    transform: scale(1.025);
  }

  100% {
    opacity: 1;
    transform: none;
  }
`

export const ExportModalDIV = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: calc(var(--SiteNav--z-index) + 1);
  width: 100vw;
  height: 100vh;
  animation: ${ModalAnimationInKeyframes} 0.3s forwards ease-out;

  &.is-closing {
    animation: ${ModalAnimationInKeyframes} 0.3s reverse forwards;
  }
`

export const ExportModalOverlayBUTTON = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(--color--cobalt-600);
  opacity: 0.6;
`

export const ExportModalContentDIV = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100vw - 30px);
  max-width: 862px;
  background: white;
  border-radius: 4px;
  padding: var(--spacing--M);
  box-shadow: var(--elevation--S);
  text-align: center;

  .close-button {
    position: absolute;
    top: 0;
    right: 0;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color--charcoal-600);

    &:hover,
    &:active {
      color: var(--color--charcoal-700);
    }
  }

  .icon,
  h4 {
    margin-bottom: var(--spacing--S);
  }

  .HubspotForm {
    margin: 0 auto;
  }

  .actions {
    max-width: 400px;
    margin: 0 auto;

    .Button {
      width: 100%;
      white-space: nowrap;
      margin-bottom: 8px;
    }

    .Button:last-of-type {
      margin-right: 0;
      margin-bottom: 0;
      line-height: 48px;
    }

    ${MEDIA_QUERIES.S} {
      display: flex;
      justify-content: center;

      .Button {
        width: auto;
        margin-right: 30px;
        margin-bottom: 0;
      }
    }
  }
`